import React from "react";
import "./Projects.css";
import Jello from "react-reveal/Jello";

const Projects = () => {
  return (
    <>
      <div className="container project" id="projects">
        <h2 className="col-12 mt-3 mb-1 text-center text-uppercase">
          TOP RECENT PROJECTS
        </h2>
        <hr />
        <p className="pb-3 text-center">
          here are my top 3 recent project with live links and source code. I
          have also mentioned main tech stack used in these projects. These are
          just few of many projects made by me, check them out on my github
          profile.
        </p>
        {/* card design */}

        <div className="row projCard " id="ads">
          <div className="col-md-4   mt-5">
            <div className="card rounded">
              <Jello>
                <div className=" card-image">
                  <span className="card-notify-badge ">MERN Stack+</span>
                  <a
                    href="https://user-images.githubusercontent.com/123864184/275349518-d4a865ff-cebd-499e-b4c0-11ab3d0c3c26.png"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src="https://user-images.githubusercontent.com/123864184/275349518-d4a865ff-cebd-499e-b4c0-11ab3d0c3c26.png"
                      alt="project-3"
                    />
                  </a>
                </div>
              </Jello>
              <div className="card-image-overly m-auto mt-3 ">
                <span className="card-detail-badge">MongoDb</span>
                <span className="card-detail-badge">Express</span>
                <span className="card-detail-badge">React</span>
                <span className="card-detail-badge">Node</span>
              </div>
              <div className="card-body text-center  ">
                <div className="ad-title m-auto">
                  <h5 className="text-uppercase ">Amazin Deals WebApp</h5>
                </div>
                <a
                  className="ad-btn mb-2 "
                  href="https://chocolate-sea-urchin-garb.cyclic.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  View
                </a>
              </div>
            </div>
          </div>
          <div className="col-md-4 mt-5">
            <div className="card rounded cardBody">
              <Jello>
                <div className=" card-image">
                  <span className="card-notify-badge">Full Stack+</span>
                  <a
                    href="https://comrate.in/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src="https://i.imgur.com/6fkjfub.png"
                      alt="project-1"
                    />
                  </a>
                </div>
              </Jello>
              <div className="card-image-overly m-auto mt-3 ">
                <span className="card-detail-badge">JavaScript</span>
                <span className="card-detail-badge">php</span>
                <span className="card-detail-badge">Dbeaver</span>
                <span className="card-detail-badge">BS</span>
              </div>
              <div className="card-body text-center mb-2">
                <div className="ad-title m-auto">
                  <h5 className="text-uppercase ">Comrate :) </h5>
                </div>
                <a
                  className="ad-btn  "
                  href="https://comrate.in/"
                  target="_blank"
                  rel="noreferrer"
                >
                  View
                </a>
              </div>
            </div>
          </div>

          <div className="col-md-4 mt-5">
            <div className="card rounded cardBody">
              <Jello>
                <div className=" card-image">
                  <span className="card-notify-badge">Full Stack</span>
                  <a
                    href="https://user-images.githubusercontent.com/123864184/268933157-7a30efc7-5a6a-4cd0-8bac-ae3725339d4a.png"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src="https://user-images.githubusercontent.com/123864184/268933157-7a30efc7-5a6a-4cd0-8bac-ae3725339d4a.png"
                      alt="project-1"
                    />
                  </a>
                </div>
              </Jello>
              <div className="card-image-overly m-auto mt-3 ">
                <span className="card-detail-badge">Node</span>
                <span className="card-detail-badge">Express</span>
                <span className="card-detail-badge">React</span>
                <span className="card-detail-badge">Mongodb</span>
              </div>
              <div className="card-body text-center mb-2">
                <div className="ad-title m-auto">
                  <h5 className="text-uppercase ">FoodNow Website</h5>
                </div>
                <a
                  className="ad-btn  "
                  href="https://github.com/Heroshi1947/FoodNow-webApp"
                  target="_blank"
                  rel="noreferrer"
                >
                  View
                </a>
              </div>
            </div>
          </div>

          <div className="col-md-4 mt-5">
            <div className="card rounded cardBody">
              <Jello>
                <div className=" card-image">
                  <span className="card-notify-badge">Full Stack</span>
                  <a
                    href="https://food-now-web-app.vercel.app/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src="https://user-images.githubusercontent.com/123864184/268933157-7a30efc7-5a6a-4cd0-8bac-ae3725339d4a.png"
                      alt="project-1"
                    />
                  </a>
                </div>
              </Jello>
              <div className="card-image-overly m-auto mt-3 ">
                <span className="card-detail-badge">Node</span>
                <span className="card-detail-badge">Express</span>
                <span className="card-detail-badge">React</span>
                <span className="card-detail-badge">Mongodb</span>
              </div>
              <div className="card-body text-center mb-2">
                <div className="ad-title m-auto">
                  <h5 className="text-uppercase ">FoodNow Website</h5>
                </div>
                <a
                  className="ad-btn  "
                  href="https://github.com/Heroshi1947/FoodNow-webApp"
                  target="_blank"
                  rel="noreferrer"
                >
                  View
                </a>
              </div>
            </div>
          </div>

          <div className="col-md-4 mt-5">
            <div className="card rounded cardBody">
              <Jello>
                <div className=" card-image">
                  <span className="card-notify-badge">React+</span>
                  <a
                    href="https://user-images.githubusercontent.com/123864184/278397661-ff626dfc-e618-48e0-852f-7297daffc51c.png"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src="https://user-images.githubusercontent.com/123864184/278397661-ff626dfc-e618-48e0-852f-7297daffc51c.png"
                      alt="project-5"
                    />
                  </a>
                </div>
              </Jello>
              <div className="card-image-overly m-auto mt-3 ">
                <span className="card-detail-badge">Node</span>
                <span className="card-detail-badge">Express</span>
                <span className="card-detail-badge">React</span>
                <span className="card-detail-badge">Vite</span>
              </div>
              <div className="card-body text-center mb-2">
                <div className="ad-title m-auto">
                  <h5 className="text-uppercase "> Voice->Text webApp </h5>
                </div>
                <a
                  className="ad-btn  "
                  href="https://speak-to-write-app.onrender.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  View
                </a>
              </div>
            </div>
          </div>

          <div className="col-md-4 mt-5">
            <div className="card rounded">
              <Jello>
                <div className=" card-image">
                  <span className="card-notify-badge">React App</span>
                  <a
                    href="https://user-images.githubusercontent.com/123864184/269621168-410b24ba-0bca-45e9-8735-d712698c8cea.png"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src="https://user-images.githubusercontent.com/123864184/269621168-410b24ba-0bca-45e9-8735-d712698c8cea.png"
                      alt="project-2"
                    />
                  </a>
                </div>
              </Jello>
              <div className="card-image-overly m-auto mt-3">
                <span className="card-detail-badge">Hbs</span>
                <span className="card-detail-badge">Express</span>
                <span className="card-detail-badge">Jquery</span>
                <span className="card-detail-badge">Mongodb</span>
              </div>
              <div className="card-body text-center  mb-2">
                <div className="ad-title m-auto">
                  <h5 className="text-uppercase ">Business WebApp</h5>
                </div>

                <a
                  className="ad-btn m "
                  href="https://github.com/Heroshi1947/Basic-MERN-Stack-Website"
                  target="_blank"
                  rel="noreferrer"
                >
                  View
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Projects;
